import { mapState } from 'vuex';
import VForm, { cloneDeep, debounce } from './vform';
import { V_FORM_ENUM } from './enum';
import { vformComponentsMap } from './use';
import { setWidgetValue } from './method';
// 专门提供混合
const {
  VFormSDK: {
    ContainerWrapper,
    emitter,
    FormItemWrapper,
    fieldMixin, i18n,
    StaticContentWrapper,
    ContainerItemWrapper,
    containerItemMixin,
    containerMixin: _containerMixin
  }
} = VForm;
export const baseMixins = {
  props: {
    parentWidget: Object,
    parentList: Array,
    widget: Object,
    indexOfParentList: Number,
    designer: Object,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    }
  },
  components: { FormItemWrapper },
  mixins: [emitter, fieldMixin, i18n],
  inject: ['refList'],
  data() {
    return {
      oldFieldValue: undefined,
      rules: [],
      formItemClass: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo,
      userId: (state) => state.user.userInfo?.userId
    }),
    bind() {
      return this.$props;
    },
    // 属性数据
    options() {
      return this.field.options;
    },
    isH5() {
      const type = this.vFormMode === V_FORM_ENUM.runtime ? this.refList.v_form_ref.$attrs.flowLayoutType : this.formConfig.layoutType;
      return type === 'H5';
    },
    // 编辑状态
    isEdit() {
      return !(this.options.disabled || this.isReadMode);
    },
    // 项目id
    prjId() {
      const { formModel } = this;
      const prjField = this.getFormRef()?.$attrs?.prjField;
      return prjField ? formModel[prjField] : this.prjInfo.prjId;
    },
    // 是否是发起状态
    createStatus() {
      return false;
    },
    // 当前拖拽组件对应的表单数据
    curFieLdForm() {
      let formData = this.formModel;
      if (this.subFormItemFlag) {
        const subFormData = this.formModel[this.subFormName] || [{}];
        formData = subFormData[this.subFormRowIndex] || formData;
      }
      return formData;
    },
    // 默认数据
    vmDefaultValue() {
      const defaultValue = this.defaultValue || this.options.defaultValue;
      return defaultValue;
    },
    isRealModel() {
      return this.curFieLdForm[this.options.name] !== undefined;
    },
    // 组件对应上级表单数据
    fieldModel: {
      get() {
        return this.curFieLdForm[this.options.name]; // || cloneDeep(this.vmDefaultValue);
      },
      set(value) {
        if (this.isEdit) {
          const oldValue = cloneDeep(this.fieldModel); // || cloneDeep(this.vmDefaultValue);
          this.syncUpdateFormModel(value);
          this.emitFieldDataChange(value, oldValue);
          this.withUpdate(value);
        }
      }
    },
    // 表单状态
    vFormMode() {
      return this.designState ? V_FORM_ENUM.design
        : this.getFormRef()?.previewState ? V_FORM_ENUM.preview
          : V_FORM_ENUM.runtime;
    },
    isInit() {
      return this.getFormRef()?.$parent?.isInit;
    }
  },
  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initOptionItems();
    this.initEventHandler();
    this.buildFieldRules();
    this.handleOnCreated();
  },
  mounted() {
    this.handleOnMounted();
    this.initFieldModel();
  },
  beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    // 绕开禁用规则,赋值
    forceSetValue(value) {
      const oldValue = cloneDeep(this.fieldModel) || cloneDeep(this.vmDefaultValue);
      setWidgetValue.call(this, this.options.name, value);
      this.withUpdate(value);
      this.syncUpdateFormModel(value);
      this.emitFieldDataChange(value, oldValue);
    },
    emitValidate() {
      this.dispatch('VFormRender', 'fieldValidation', [this.getPropName()]);
    },
    watchField(fieldList = [], getListFn, preventFn) {
      if (!getListFn) return;
      const { subFormRowIndex: rowIndex, parentWidget } = this;
      const subFormName = parentWidget?.options?.name;
      const bfn = debounce(getListFn, 200);
      const fn = () => {
        const disabled = preventFn && preventFn.call(this);
        if (!disabled) bfn();
      };
      fn();
      if (!fieldList?.length) return;
      const runtime = this.getFormRef();
      const scheduler = (...arg) => {
        const [key, , , , formName, index] = arg;
        const effect = fieldList.indexOf(key) !== -1;
        // 只有从表内的组件才会监听字表数据 , 表名不对或者行数不一致都不会相应
        if (formName && subFormName && (formName !== subFormName || index !== rowIndex)) return;
        if (effect) fn();
      };
      // 注册事件监听,当数据变化时,调用触发器
      runtime.$on("formChange", scheduler);
      // 当前组件销毁后,需要释放监听
      this.$on("hook:destroyed", () => {
        runtime.$off("formChange", scheduler);
      });
    },
    withUpdate() { },
    onReset() { },
    resetField() {
      // 跳过子表单组件
      if (this.subFormItemFlag) return;
      const defaultValue = cloneDeep(this.vmDefaultValue);
      this.fieldModel = defaultValue;
      this.onReset();
    },
    // 触发自定义事件
    customEvent(eventName, ...args) {
      const field = this.field || this.widget;
      const eventStr = field.options[eventName];
      const componentType = field.type;
      // 设计状态不触发事件
      if (this.designState) {
        return;
      } else if (!eventStr) {
        return;
      } else {
        const fnArgNames = vformComponentsMap[componentType]?.[eventName];
        const customFn = new Function(...fnArgNames, eventStr);
        return customFn.apply(this, args);
      }
    },
    // 初始化数据 没有数据使用默认数据
    initFieldModel() {
      if (!this.designState && !this.isRealModel) {
        const value = cloneDeep(this.vmDefaultValue);
        if (this.isEdit) {
          this.fieldModel = value;
        } else {
          this.forceSetValue(value);
        }
      }
    },
    // 禁止设计态操作
    preventDesign() {
      if (this.vFormMode === V_FORM_ENUM.design) throw new Error();
    },
    // 禁止预览默认操作
    preventPreview() {
      if (this.vFormMode === V_FORM_ENUM.preview) this.throwErr('预览模式下禁止操作');
    },
    throwErr(msg) {
      this.$message.warning(msg);
      throw new Error(msg);
    },
    syncUpdateFormModel(value) {
      this.preventDesign();
      this.$set(this.curFieLdForm, this.field.options.name, value);
    }
  }
};
export const containerMixin = {
  mixins: [_containerMixin, baseMixins],
  components: {
    ContainerWrapper
  }
};
export const containerWeightMixin = {
  mixins: [containerItemMixin, baseMixins]
};
export const staticMixins = {
  mixins: [_containerMixin, baseMixins],
  props: { field: Object },
  inject: ['globalOptionData', 'globalModel'],
  components: {
    StaticContentWrapper, ContainerItemWrapper
  }
};
// 侧边配置数据
export const settingMixin = {
  components: {
    fieldSetting: () => import('./field-setting/index.vue'),
    tableSetting: () => import('./table-setting/index.vue'),
    tableFieldSetting: () => import('./table-setting/field.vue')
  },
  props: {
    designer: { type: Object, default: () => ({}) },
    optionModel: { type: Object, default: () => ({}) },
    selectedWidget: Object
  },
  provide() { return { designer: this.designer }; },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userId: (state) => state.user.userInfo?.userId
    })
  }
};
export const formInputMixins = {
  inject: {
    elForm: {
      default: {}
    }
  },
  computed: {
    inputClass() {
      const inputSize = this.options.size || this.elForm.size || (this.$ELEMENT || {}).size;
      return inputSize ? "el-input--" + inputSize : "";
    }
  }
};
